"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPortfolioCovenantLoanTapeMetadataParams = exports.isAllPortfolioCovenantLoanTapeMetadataParams = exports.isPortfolioCovenantLoanTapeMetadataArray = exports.isPortfolioCovenantLoanTapeMetadata = exports.isSuccessPortfolioCovenantWithCreatedAt = exports.isSuccessPortfolioCovenantWithIdAndVersion = exports.isPortfolioCovenantWorklease = void 0;
const lodash_1 = __importDefault(require("lodash"));
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
const _isSuccessPortfolioCovenantWithCreatedAt = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SuccessPortfolioCovenantWithCreatedAtSchema,
    typeguardName: 'isSuccessPortfolioCovenantWithCreatedAt',
});
exports.isPortfolioCovenantWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantWorkleaseSchema,
    typeguardName: 'isPortfolioCovenantWorklease',
});
exports.isSuccessPortfolioCovenantWithIdAndVersion = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SuccessPortfolioCovenantWithIdAndVersionSchema,
    typeguardName: 'isSuccessPortfolioCovenantWithIdAndVersion',
});
const isSuccessPortfolioCovenantWithCreatedAt = (obj) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'SuccessPortfolioCovenantWithCreatedAt',
    })) {
        return false;
    }
    const stringifiedTimestamps = Object.assign(Object.assign({}, obj), { created_at: obj.created_at.toISOString(), updated_at: obj.updated_at.toISOString() });
    return _isSuccessPortfolioCovenantWithCreatedAt(stringifiedTimestamps);
};
exports.isSuccessPortfolioCovenantWithCreatedAt = isSuccessPortfolioCovenantWithCreatedAt;
exports.isPortfolioCovenantLoanTapeMetadata = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantLoanTapeMetadataSchema,
    typeguardName: 'isPortfolioCovenantLoanTapeMetadata',
});
const isPortfolioCovenantLoanTapeMetadataArray = (obj, logOptions) => Array.isArray(obj) &&
    lodash_1.default.every((el) => (0, exports.isPortfolioCovenantLoanTapeMetadata)(el, logOptions));
exports.isPortfolioCovenantLoanTapeMetadataArray = isPortfolioCovenantLoanTapeMetadataArray;
exports.isAllPortfolioCovenantLoanTapeMetadataParams = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AllPortfolioCovenantLoanTapeMetadataParamsSchema,
    typeguardName: 'isAllPortfolioCovenantLoanTapeMetadataParams',
});
exports.isPortfolioCovenantLoanTapeMetadataParams = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantLoanTapeMetadataParamsSchema,
    typeguardName: 'isPortfolioCovenantLoanTapeMetadataParams',
});
//# sourceMappingURL=portfolioCovenant.js.map